import { render, staticRenderFns } from "./StackElements.vue?vue&type=template&id=2abb8242"
import script from "./StackElements.vue?vue&type=script&lang=js"
export * from "./StackElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports